var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "post-card" }, [
    _c("div", { staticClass: "post-card__image-container" }, [
      _c("img", {
        staticClass: "post-card__image",
        attrs: {
          src: _vm.media.source_url,
          alt: _vm.post.featured_media.alt_text,
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "post-card__body" }, [
      _c("h3", { staticClass: "post-card__title" }, [
        _vm._v(_vm._s(_vm.post.title.rendered)),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "post-card__publish-date" }, [
        _vm._v(_vm._s(_vm.postDate)),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "post-card__excerpt" }, [
        _vm._v(_vm._s(_vm._f("stripTags")(_vm.post.excerpt.rendered))),
      ]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "post-card__read-more", attrs: { href: _vm.post.link } },
        [_vm._v("Read More ➤")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/PostCard.vue